import { FiChrome } from 'react-icons/all';
import SitePage from '../components/site-page';
import AddSite from '../components/site-page/add-site';
import EditSite from '../components/site-page/edit-site';

const routes = [
  { name: 'Sites', icon: FiChrome, path: '/', component: <SitePage /> },
];

export const subRoutes = [
  // Sites paths
  { name: 'Add Site', path: '/add', component: <AddSite /> },
  { name: 'Edit Site', path: '/edit', component: <EditSite /> },
];
export default routes;
